<div class="header-conatiner">
  <app-holiday-calendar *ngIf="isHolidayListOpen" [closeHolidayList]="closeHolidayList.bind(this)"></app-holiday-calendar>
  <div class="no-filter">
    <img class="litmusworld-logo"  [ngClass]="{'noCursor': isAccountsRoute}" src="assets/images/LW-logo.svg" (click)="userCurrentAccess()"  alt="Litmusworld Logo"/>
    <div class="project-type-dropdown-conatiner"  *ngIf="isShowProject && selectedProjectType" >
      <div class="project-type" (click)="projectTypeOptions.length > 1 ? onProjectTypeClick('') : ''">
        <span class="project-type-text">{{ selectedProjectType }}</span>
        <span *ngIf="projectTypeOptions.length > 1"><img class="orange-arrow" [ngStyle]="{ transform: isProjectTypeOpen ? 'rotate(180deg)' : '' }" src="assets/images/arrow_drop_down_24dp_FFFFFF_FILL0_wght400_GRAD0_opsz24.svg"></span>
      </div>
      <div class="project-type-dropdown-content" *ngIf="isProjectTypeOpen">
        <ul>
          <li *ngFor="let option of projectTypeOptions" (click)="onProjectTypeClick(option)">{{option.name}}</li>
        </ul>
      </div>
    </div>
     <div *ngIf="breadcrumbProject?.status">
          <span class="status-badge" [ngbTooltip]='breadcrumbProject?.status' tooltipClass="custom-tooltip-background" [ngClass]="getStatusClass(breadcrumbProject?.status)">
          <!-- {{ breadcrumbProject?.status }} -->
        </span>
        </div>
    <div class="breadcrumb-container" #breadCrumbDropdown *ngIf="isBreadcrumbVisible">
        <div class="accountNameContainer" *ngIf="breadcrumbAccount?.name" [ngbTooltip]='breadcrumbAccount?.name' tooltipClass="custom-tooltip-background">
          
          <div *ngIf = '!isBillingDashboard' [ngClass]="isProjectPage ? 'accountName' : 'projectName'" [ngStyle]="{'pointer-events': removeClickEventFromAccount ? 'none' : 'auto', 'cursor': removeClickEventFromAccount ? 'default' : 'pointer'}" (click)="onBreadcrumbClick(breadcrumbAccount, 'Account')">{{breadcrumbAccount?.name}}</div>
          
          <div *ngIf = 'isBillingDashboard' [ngClass]="isProjectPage ? 'accountName' : 'projectName'" [ngStyle]="{'pointer-events': removeClickEventFromAccount ? 'none' : 'auto', 'cursor': removeClickEventFromAccount ? 'default' : 'pointer'}" (click)="onBreadcrumbClick(breadcrumbAccount, 'billing')">{{breadcrumbAccount?.name}}</div>
          <div class="breadcrumb-arrow-account">></div>
        </div>
      <div class="projectNameContainer" *ngIf="breadcrumbProject?.name"  [ngbTooltip]='breadcrumbProject?.name'  tooltipClass="custom-tooltip-background">
        <div class="projectName"  [ngStyle]="{'pointer-events': removeClickEventFromProject ? 'none' : 'auto', 'cursor': removeClickEventFromProject ? 'default' : 'pointer'}"  (click)="onBreadcrumbClick({breadcrumbProject, breadcrumbAccount}, 'Project')">
          {{breadcrumbProject?.name}}
        </div>
        <div class="breadcrumb-arrow">></div>
    </div>
      <div class="tabNameContainer">
        <div class="tabName currentTab">{{breadcrumbTab}}</div>
      </div>
        <div class="tabNameContainer">
       
      </div>
    </div>
  </div>
  <div class="filter">
    <app-ltms-daterange-picker class="date-picker" [restricted]="restrictedDate" *ngIf="headerState.showCalendarButton && isCalendarActive"></app-ltms-daterange-picker>
    <img class="brand-logo" [src]="logoUrl" alt="Logo" />
    <!-- <div class="help-center">
      <img src="assets/images/question.svg" />
    </div> -->
    <!-- <app-web-push-notification></app-web-push-notification> -->
    <div *ngIf="showUserButton" #userProfile [ngClass]="{'active': isProfileDropdownVisible}" class="user-profile-container">
      <span [ngClass]="{'active': isProfileDropdownVisible}" class="user-profile-logo" (click)="toggleProfile()">{{name_logo}}</span>
      <div *ngIf="isProfileDropdownVisible" class="user-profile-dropdown">
        <span *ngIf="fullName" class="user-fullname">{{fullName}}</span>
        <span class="user-email-address">{{ email_address }}</span>
        <span class="custom-line"></span>
        <span class="button-container">
          <span class="button profile-btn" *ngIf="headerState.showChangeAccessLevelButton" [ngStyle]="{'width': showChangePasswordButton ? 'auto' : '100%', 'justify-content': showChangePasswordButton ? 'flex-start' : 'center'}" (click)="changeAccessLevel()">Change access</span>
          <span class="button profile-btn" *ngIf="showChangePasswordButton" [ngStyle]="{'width': headerState.showChangeAccessLevelButton ? 'auto' : '100%', 'justify-content': headerState.showChangeAccessLevelButton ? 'flex-start' : 'center'}" (click)="openModal()">Change password</span>
        </span>
        <span class="button-container">
          <span id="logoutbtn" class="button sign-out-button" (click)="logout()">Sign out</span>
        </span>
      </div>
    </div>
    <span class="three-dot-container" #threeDotContainer>
      <img [ngClass]="{'active': dropdownVisible}" class="menu-three-dots" src="assets/images/vertical-3-dots.svg" alt="Menu" (click)="toggleDropdown($event)"/>
      <div *ngIf="dropdownVisible" class="three-dot-dropdown-menu">
        <ul>
          <li *ngIf="isProjectLevelConversationPreview" (click)="openPreviewURL()">{{ "HEADER_TEXT_CONVERSATION_PREVIEW" | translate }}</li>
          <!-- <li>{{ "HEADER_TEXT_USER_GUIDE" | translate }}</li> -->
          <!-- <li>{{ "HEADER_TEXT_PLATFORM_SLA" | translate }}</li> -->
          <!-- <li>{{ "HEADER_TEXT_SHARE_FEEDBACK" | translate }}</li> -->
          <li (click)="toggleFullScreen()">{{ fullScreenButtonText }}</li>
          <li *ngIf=" isHolidayListVisible" (click)="openHolidayList($event)">{{ "HEADER_TEXT_HOLIDAY_LIST" | translate }}</li>
          <li (click)="toggleDownloadSideBar($event)">Downloads</li>
        </ul>
      </div>
    </span>
  </div>
</div>

<div
  class="modal modal-dialog-centered usr-setting-landing-pop-up"
  id="userProfile"
  role="dialog"
  *ngIf="showModel"
>
  <script
    type="text/javascript"
    src="https://www.google.com/recaptcha/api.js"
  ></script>
  <div class="modal-dialog" role="document">
    <div class="modal-content usr-setting-pop-up-field">
      <div class="modal-header">
        <h2 class="modal-title usr-setting-pop-up-header">
          {{ "CHANGE_PASSWORD" | translate }}
        </h2>
        <button type="button" class="btn-close" (click)="closeModal()"></button>
      </div>
      <div class="modal-body usr-setting-pop-up-summary">
        <form [formGroup]="passwordResetForm" (ngSubmit)="onSubmit()">
          <div class="form-group row form-margin">
            <label for="old-password" class="col-sm-4">
              <p class="col-label-clr col-label-align">Current Password</p>
            </label>
            <div class="col-sm-8 col-label-clr" id="show_hide_password">
              <input
                type="password"
                formControlName="current_password"
                class="form-control"
                placeholder="Your current password"
                [ngClass]="{ 'highlight-wrong-password': invalidCurrentPassword }"
                (input)="onPasswordInputChange('current_password')"
                id="currentPassword"
              />
            </div>
          </div>
          <hr class="hr-line">
          <div class="form-group row form-margin">
            <label for="new-password" class="col-sm-4 content-margin">
              <p class="col-label-clr col-label-align">New Password</p>
            </label>
            <div class="col-sm-8 col-label-clr input-container">
              <input
                [type]="showNewPasswordEye ? 'text' : 'password'"
                formControlName="new_password"
                class="form-control"
                placeholder="Enter new password"
                [ngClass]="{ 'highlight-wrong-password': isWrongPassword }"
                (input)="onPasswordInputChange('new_password')"
                id="newPassword"
                autocomplete="off"
                required
              />
              <!-- <i
                [class]="showNewPasswordEye ? 'fa fa-eye' : 'fa fa-eye-slash'"
                (click)="showPassword('newPassword')"
                aria-hidden="true"
              ></i> -->
              <img
                src="assets/images/eye_open.svg"
                class="change-password-eye"
                alt="Eye Open SVG"
                aria-hidden="true"
                *ngIf="showNewPasswordEye"
                (click)="showPassword('newPassword')"
              />
              <img
                src="assets/images/eye_closed.svg"
                class="change-password-eye"
                alt="Eye Closed SVG"
                aria-hidden="true"
                *ngIf="!showNewPasswordEye"
                (click)="showPassword('newPassword')"
              />
            </div>
            <span class="col-sm-4"></span>
            <span class="col-sm-8 new-password-class" *ngIf="!isNewPasswordValidate">Password must be 8 characters long, with 1 uppercase, 1 lowercase, 1 number, and 1 special character.</span>
          </div>
          <hr class="hr-line">
          <div class="form-group row form-margin">
            <label for="confirm-password" class="col-sm-4 content-margin">
              <p class="col-label-clr col-label-align">Confirm Password</p>
            </label>
            <div class="col-sm-8 col-label-clr input-container">
              <input
                [type]="showConfirmPasswordEye ? 'text' : 'password'"
                formControlName="confirm_password"
                class="form-control"
                placeholder="Re-enter new password"
                [ngClass]="{ 'highlight-wrong-password': isWrongPassword }"
                (input)="onPasswordInputChange('confirm_password')"
                id="confirmPassword"
                autocomplete="off"
                required
              />
              <!-- <i
                [class]="
                  showConfirmPasswordEye ? 'fa fa-eye' : 'fa fa-eye-slash'
                "
                (click)="showPassword('confirmPassword')"
                aria-hidden="true"
              ></i> -->
              <img
                src="assets/images/eye_open.svg"
                class="change-password-eye"
                alt="Eye Open SVG"
                aria-hidden="true"
                *ngIf="showConfirmPasswordEye"
                (click)="showPassword('confirmPassword')"
              />
              <img
                src="assets/images/eye_closed.svg"
                class="change-password-eye"
                alt="Eye Closed SVG"
                aria-hidden="true"
                *ngIf="!showConfirmPasswordEye"
                (click)="showPassword('confirmPassword')"
              />
            </div>
            <!-- <span class="col-sm-4"></span>
            <span class="col-sm-8 confirm-password-class" *ngIf="!isConfirmPasswordValidate">Password must be 8 character long and include 1 uppercase 1 lowercase, 1 number and 1 special character.</span> -->
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary cancel-btn"
          data-dismiss="modal"
          (click)="closeModal()"
        >
          {{ "CANCEL" | translate }}
        </button>
        <button
          type="button"
          class="btn save-usr-profile-btn"
          [class] = "isSubmitButtonDisable ? 'save-usr-profile-btn-disable' : 'save-usr-profile-btn-active'"
          (click)="onSubmit()"
          [disabled] = "isSubmitButtonDisable"
        >
          {{ "SAVE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
<ng-container *ngIf="changeAccessLevelContainerVisible">
  <app-change-access-level></app-change-access-level>
</ng-container>